import styled from "@emotion/styled";
import { ImageListItem } from "@mui/material";
import theme from "../../../../../theme";

export const MediaAssetItemStyle = styled(ImageListItem)`
  width: 100%;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  border: 1px solid ${theme.palette.divider};
  border-radius: 10px;
  cursor: pointer;
`;
